import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-24 pb-16 overflow-hidden bg-gradient-to-br from-background-50 to-primary-50">
      <div className="absolute -top-8 right-0 w-64 h-64 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-secondary-200/40 blur-3xl"></div>

      <div className="relative">
        <span className="mx-auto w-20 h-20 flex items-center justify-center rounded-[2rem] bg-primary-500 text-background-50 text-3xl">
          <i className="ri-error-warning-line"></i>
        </span>
        <h1 className="mt-6 font-heading text-7xl md:text-9xl text-foreground-950 leading-none">
          404
        </h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">
          哎呀，这页瓜好像被切走啦。
        </p>
        <p className="mt-2 text-sm text-foreground-400">
          你访问的页面不存在或已被移除，回到前排继续围观吧。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium px-6 py-3 hover:bg-primary-600 transition whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i> 回到首页
          </Link>
          <a
            href="#feed"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-background-50 text-foreground-700 text-sm font-medium px-6 py-3 hover:border-accent-500 hover:text-primary-600 transition whitespace-nowrap"
          >
            <i className="ri-flashlight-line"></i> 去看看新瓜
          </a>
        </div>
      </div>
    </section>
  );
}